import React, { useState, useEffect, useCallback } from 'react';
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "../routes";
import { readClassicRegion, rememberClassicRegion } from "../helper/classicRegion";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import { useCookies } from 'react-cookie';

// authen
import Signin from "./authenticate/Signin";
import Signup from "./authenticate/Signup";
import ForgotPassword from "./authenticate/ForgotPassword";
import ResetPassword from "./authenticate/ResetPassword";
import ServerError from "./authenticate/ServerError";

// trang chủ
import Overview from "./dashboard/DashboardOverview";
import CustomerOverview from "./__customer__/dashboard/DashboardOverview";
import SettingOverview from "./__setting__/dashboard/DashboardOverview";
import VietlottOverview from "./__vietlott__/dashboard/DashboardOverview";
import ClassicOverview from "./__classic__/dashboard/DashboardOverview";
import LotoOverview from "./__loto__/dashboard/DashboardOverview";

// nạp tiền
import AddCharge from './fund/charge/add-charge/AddCharge'
import ChargeHistory from './fund/charge/charge-history/ChargeHistory'
import IssueCharge from './fund/charge/issue-charge/IssueCharge'
import ChargeSettings from './fund/charge/charge-settings/ChargeSettings'
import Refund from './fund/refund/add-refund/AddRefund'
import RefundHistory from './fund/refund/refund-history/RefundHistory'
import CashbackHistory from './fund/cashback/cashback-history/CashbackHistory'
import MoneyLogLink from './fund/money-log/MoneyLogLink'
import MoneyLogHistory from './fund/money-log-history/MoneyLogHistory'

// quản lý
import Cart from './management/cart/Cart'
import Ticket from './management/ticket/Ticket';
import TicketDetail from './management/ticket/TicketDetail';
import MBRefund from './management/mb-refund/MBRefund';
import MBDoisoat from './management/mb-doisoat/MBDoisoat';
import CartGroup from './management/cart-group/CartGroup';
import CartGroupCreate from './management/cart-group/CartGroupCreate';
import CartGroupDetail from './management/cart-group/CartGroupDetail';

import WithdrawRequest from './management/withdraw-request/list/WithdrawRequest'
import WithdrawSettings from './fund/withdraw/withdraw-settings/WithdrawSettings'
import WithdrawRequestConfirmed from './management/withdraw-request/confirmed/WithdrawRequest'
import WithdrawSummary from './statistic/withdraw-summary/WithdrawSummary'

// kết quả
import Lotto535Result from './result/lotto535/Lotto535'
import KenoResult from './result/keno/Keno'
import PowerResult from './result/power/Power'
import MegaResult from './result/mega/Mega'
import Max3dResult from './result/max3d/Max3d'
import Max3dProResult from './result/max3dpro/Max3dPro'

// thống kê
import CashBack from './statistic/cashback/CashBack'
import DeletedTicket from './statistic/by-deleted-ticket/ByDeletedTicket'
import RevenueByPrintedTicket from './statistic/by-printed-ticket/ByPrintedTicket'
import RevenueByDoneTicket from './statistic/by-done-ticket/ByDoneTicket'
import RevenueByWaitingTicket from './statistic/by-waiting-ticket/ByWaitingTicket'
import ChargeSummary from './statistic/charge-summary/ChargeSummary'
import TransactionSummary from './statistic/transaction-summary/TransactionSummary'
import Reward from './__vietlott__/reward/Reward';
import BigReward from './__vietlott__/big-reward/Reward';
import NewUserSummary from './statistic/new-user/NewUser'

// kỳ quay
import DayOff from './period/day-off/DayOff'
import KenoPeriod from './period/keno/Keno'
import Lotto535Period from './period/lotto535/Lotto535'
import PowerPeriod from './period/power/Power'
import MegaPeriod from './period/mega/Mega'
import Max3dPeriod from './period/max3d/Max3d'
import Max3dProPeriod from './period/max3dpro/Max3dPro'

// thông tin chung
import Devices from './commons/device/Devices'
import Games from './commons/game/Games'
import PaymentMethod from './commons/payment-method/PaymentMethod'
import Account from './commons/account/Account'
import Bank from './commons/bank/Bank'
import Banner from './commons/banner/Banner'
import Privacy from './commons/privacy/Privacy'
import Contact from './commons/contact/Contact'
import Invite from './commons/invite/Invite'
import Notification from './commons/notification/Notification'

// tài khoản
import FirstAgent from './account/first-agent/FirstAgent';
import SecondAgent from './account/second-agent/SecondAgent';
import Collaborator from './account/collaborator/Collaborator';
import User from './account/user/User'
import Employee from './account/employee/Employee'
import AdminManagement from './admin/management/AdminManagement'
import TicketEmployeeManagement from './admin/ticket-employees/TicketEmployeeManagement'

import SystemNotification from './systems/notification/SystemNotification';
import { persistAdminSession, isSuperAdminUser } from '../helper/adminSession';

// classic
import ClassicListReward from './__classic__/list-reward/ListReward';
import ClassicChannel from './__classic__/channel/Channel';
import ClassicResult from './__classic__/result/Result';
import ClassicReward from './__classic__/reward/Reward';
import ClassicBigReward from './__classic__/big-reward/Reward';
import ClassicNewCart from './__classic__/new-cart/Cart';
import ClassicDoneCart from './__classic__/done-cart/Cart';
import ClassicTicket from './__classic__/ticket/Ticket';
import ClassicTicketStorage from './__classic__/ticket-storage/TicketStorage';
import ClassicTicketSales from './__classic__/sales-ticket-storage/SalesTicketStorage';
import ClassicStatistic from './__classic__/statistic/Statistic';
import ClassicStatisticByUnmarketableTicket from './__classic__/statistic-by-unmarketable-ticket/Statistic';
import ClassicStatisticByTicket from './__classic__/statistic-by-ticket/Statistic';
import ClassicSearch from './__classic__/search/Search';
import ClassicPeriod from './__classic__/period/Period';

import LotoChannel from './__loto__/channel/Channel';
import LotoPeriod from './__loto__/period/Period';
import LotoSearch from './__loto__/search/Search';
import LotoReward from './__loto__/reward/Reward';
import LotoBigReward from './__loto__/big-reward/Reward';
import LotoNewCart from './__loto__/new-cart/Cart';
import LotoDoneCart from './__loto__/done-cart/Cart';
import LotoStatisticByTicket from './__loto__/statistic-by-ticket/Statistic';


import { checkToken } from '../controller/api/auth';
import { messaging } from '../firebase';
import { getToken } from 'firebase/messaging';
import { submitFbToken } from '../controller/api/messageToken';
import ClassicMNSidebar from '../components/ClassicMNSidebar';
import ClassicMTSidebar from '../components/ClassicMTSidebar';
import ClassicMBSidebar from '../components/ClassicMBSidebar';
import ChargeList from './statistic/charge-list/ChargeList';
import Maintained from './__vietlott__/maintained/Maintained';
import TicketRoll from './__setting__/ticket-roll/TicketRoll';
import WorkerQueue from './__setting__/worker-queue/WorkerQueue';
import ServerBenchmark from './__setting__/server-benchmark/ServerBenchmark';
import TransactionList from './statistic/transaction-list/TransactionList';
import BankSummary from './statistic/bank-summary/BankSummary';
import EwalletAndPaymentGatewaySummary from './statistic/ewallet-and-payment-gateway-summary/EwalletAndPaymentGatewaySummary';
import EwalletAndPaymentGatewayDetail from './statistic/ewallet-and-payment-gateway-detail/EwalletAndPaymentGatewayDetail';
import LotoSidebar from '../components/LotoSidebar';
import CustomerSidebar from '../components/CustomerSidebar';
import SettingSidebar from '../components/SettingSidebar';

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => (<> <Preloader show={loaded ? false : true} /> <Component {...props} /> </>)} />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

const RouteWithClassicMNSidebar = ({ component: Component, region, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      rememberClassicRegion(region)
      return (
      <>
        <ClassicMNSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
      )
    }}
    />
  );
};

const RouteWithClassicMTSidebar = ({ component: Component, region, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      rememberClassicRegion(region)
      return (
      <>
        <ClassicMTSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
      )
    }}
    />
  );
};

const RouteWithClassicSharedSidebar = ({ component: Component, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      const region = readClassicRegion(props.location.search)
      rememberClassicRegion(region)
      const Sidebar = region === 'MT' ? ClassicMTSidebar : region === 'MB' ? ClassicMBSidebar : ClassicMNSidebar

      return (
      <>
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={region} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
      )
    }}
    />
  );
};

const RouteWithClassicMBSidebar = ({ component: Component, region, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      rememberClassicRegion(region)
      return (
      <>
        <ClassicMBSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
      )
    }}
    />
  );
};

const RouteWithLotoSidebar = ({ component: Component, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <LotoSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={rest.region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

const RouteWithCustomerSidebar = ({ component: Component, superAdminOnly, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      if (superAdminOnly && !isSuperAdminUser()) {
        return <Redirect to={Routes.Overview.path} />
      }

      return (
      <>
        <CustomerSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={rest.region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
      )
    }}
    />
  );
};

const RouteWithSettingSidebar = ({ component: Component, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <SettingSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={rest.region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

const RouteWithSuperAdminSidebar = ({ component: Component, ...rest }) => {
  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isSuperAdminUser()) {
          return <Redirect to={Routes.Overview.path} />
        }
        return (
          <>
            <SettingSidebar />
            <main className="content">
              <Navbar />
              <Component {...props} region={rest.region || ''} />
              <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
            </main>
          </>
        )
      }}
    />
  );
};

export default () => {
  const [cookies] = useCookies(['lottmekong']);

  const history = useHistory()

  const checkTokenFunc = useCallback(async () => {
    if (!cookies.lottmekong) {
      history.replace(Routes.Signin.path)
    } else {
      const response = await checkToken(cookies.lottmekong)

      if (response.status === 'success') {
        persistAdminSession({
          permission: response.permission,
          isSuperAdmin: response.isSuperAdmin,
        })

        if (history.location.pathname.startsWith(Routes.AdminManagement.path) && !isSuperAdminUser()) {
          history.replace(Routes.Overview.path)
        }

        if (history.location.pathname.startsWith(Routes.TicketEmployeeManagement.path) && !isSuperAdminUser()) {
          history.replace(Routes.Overview.path)
        }

        if (history.location.pathname.includes(Routes.Signin.path)) {
          // const permission = response.permission

          history.replace(Routes.Overview.path)

          // if (permission === '100') {
          //   history.replace(Routes.VietlottOverview.path)
          // } else if (permission === '010') {
          //   history.replace(Routes.ClassicOverview.path)
          // } else if (permission === '001') {
          //   history.replace(Routes.LotoOverview.path)
          // } else if (permission === '000') {
          //   alert('Ko có quyền')
          // } else {
          //   history.replace(Routes.Overview.path)
          // }
        } else if (history.location.pathname === Routes.Overview.path) {
          const permission = response.permission

          history.replace(Routes.Overview.path)

          // if (permission === '100') {
          //   history.replace(Routes.VietlottOverview.path)
          // } else if (permission === '010') {
          //   history.replace(Routes.ClassicOverview.path)
          // } else if (permission === '001') {
          //   history.replace(Routes.LotoOverview.path)
          // } else if (permission === '000') {
          //   alert('Ko có quyền')
          // } else {
          //   history.replace(Routes.Overview.path)
          // }
        }
      } else {
        history.replace(Routes.Signin.path)
      }
    }
  }, [cookies.lottmekong, history])

  useEffect(() => {
    checkTokenFunc()
  }, [checkTokenFunc])

  useEffect(() => {
    getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
    }).then((currentToken) => {
      submitFbToken(cookies.lottmekong, currentToken)
    }).catch((e) => {
      alert(e)
    })
  }, [cookies.lottmekong])

  return (
    <Switch>
      {/* authen */}
      <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
      <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
      <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
      <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
      <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} />

      {/* trang chủ */}
      <Route exact path={Routes.Overview.path} component={Overview} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerOverview.path} component={CustomerOverview} />
      <RouteWithSettingSidebar exact path={Routes.SettingOverview.path} component={SettingOverview} />
      <RouteWithSidebar exact path={Routes.VietlottOverview.path} component={VietlottOverview} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNOverview.path} component={ClassicOverview} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTOverview.path} component={ClassicOverview} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBOverview.path} component={ClassicOverview} />
      <RouteWithLotoSidebar exact path={Routes.LotoOverview.path} component={LotoOverview} />

      {/* CUSTOMER */}
      <RouteWithCustomerSidebar exact path={Routes.CustomerAddCharge.path} component={AddCharge} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerChargeHistory.path} component={ChargeHistory} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerIssueCharge.path} component={IssueCharge} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerChargeSettings.path} component={ChargeSettings} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerRefund.path} component={Refund} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerRefundHistory.path} component={RefundHistory} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerCashbackHistory.path} component={CashbackHistory} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerMoneyLogHistory.path} component={MoneyLogHistory} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerMoneyLogLink.path} component={MoneyLogLink} />
      <RouteWithCustomerSidebar superAdminOnly exact path={Routes.CustomerWithdrawSettings.path} component={WithdrawSettings} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerWithdrawRequestConfirmed.path} component={WithdrawRequestConfirmed} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerWithdrawRequest.path} component={WithdrawRequest} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerFirstAgent.path} component={FirstAgent} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerSecondAgent.path} component={SecondAgent} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerCollaborators.path} component={Collaborator} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerUser.path} component={User} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerChargeSummary.path} component={ChargeSummary} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerNewUserSummary.path} component={NewUserSummary} />
      <RouteWithCustomerSidebar exact path={Routes.CustomerWithdrawSummary.path} component={WithdrawSummary} />

      <RouteWithCustomerSidebar exact path={Routes.MBRefund.path} component={MBRefund} />
      <RouteWithCustomerSidebar exact path={Routes.MBDoisoat.path} component={MBDoisoat} />

      {/* VIETLOTT */}
      <RouteWithSidebar exact path={Routes.VietlottCart.path} component={Cart} />
      <RouteWithSidebar exact path={Routes.VietlottTicket.path} component={Ticket} />
      <RouteWithSidebar exact path={Routes.VietlottTicketDetail.path} component={TicketDetail} />
      <RouteWithSidebar exact path={Routes.VietlottLotto535Result.path} component={Lotto535Result} />
      <RouteWithSidebar exact path={Routes.VietlottKenoResult.path} component={KenoResult} />
      <RouteWithSidebar exact path={Routes.VietlottPowerResult.path} component={PowerResult} />
      <RouteWithSidebar exact path={Routes.VietlottMegaResult.path} component={MegaResult} />
      <RouteWithSidebar exact path={Routes.VietlottMax3dResult.path} component={Max3dResult} />
      <RouteWithSidebar exact path={Routes.VietlottMax3dProResult.path} component={Max3dProResult} />
      <RouteWithSidebar exact path={Routes.VietlottDeletedTicket.path} component={DeletedTicket} />
      <RouteWithSidebar exact path={Routes.VietlottPrintedTicket.path} component={RevenueByPrintedTicket} />
      <RouteWithSidebar exact path={Routes.VietlottDoneTicket.path} component={RevenueByDoneTicket} />
      <RouteWithSidebar exact path={Routes.VietlottWaitingTicket.path} component={RevenueByWaitingTicket} />
      <RouteWithSidebar exact path={Routes.VietlottDayOff.path} component={DayOff} />
      <RouteWithSidebar exact path={Routes.VietlottKenoPeriod.path} component={KenoPeriod} />
      <RouteWithSidebar exact path={Routes.VietlottLotto535Period.path} component={Lotto535Period} />
      <RouteWithSidebar exact path={Routes.VietlottPowerPeriod.path} component={PowerPeriod} />
      <RouteWithSidebar exact path={Routes.VietlottMegaPeriod.path} component={MegaPeriod} />
      <RouteWithSidebar exact path={Routes.VietlottMax3dPeriod.path} component={Max3dPeriod} />
      <RouteWithSidebar exact path={Routes.VietlottMax3dProPeriod.path} component={Max3dProPeriod} />
      <RouteWithSidebar exact path={Routes.VietlottCashBack.path} component={CashBack} />
      <RouteWithSidebar exact path={Routes.VietlottTransactionSummary.path} component={TransactionSummary} />
      <RouteWithSidebar exact path={Routes.VietlottTransactionList.path} component={TransactionList} />
      <RouteWithSidebar exact path={Routes.VietlottReward.path} component={Reward} />
      <RouteWithSidebar exact path={Routes.VietlottBigReward.path} component={BigReward} />
      <RouteWithSidebar exact path={Routes.VietlottGroup.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupPending.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupActive.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupCompleted.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupRewarded.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupCancelled.path} component={CartGroup} />
      <RouteWithSidebar exact path={Routes.VietlottGroupCreate.path} component={CartGroupCreate} />
      <RouteWithSidebar exact path={Routes.VietlottGroupDetail.path} component={CartGroupDetail} />

      {/* CLASSIC */}
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicListReward.path} component={ClassicListReward} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicResult.path} component={ClassicResult} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicTicket.path} component={ClassicTicket} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicTicketStorage.path} component={ClassicTicketStorage} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicStatistic.path} component={ClassicStatistic} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicStatisticByTicket.path} component={ClassicStatisticByTicket} />
      <RouteWithClassicSharedSidebar exact path={Routes.ClassicStatisticByUnmarketableTicket.path} component={ClassicStatisticByUnmarketableTicket} />

      {/* CLASSIC MT */}
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTChannel.path} component={ClassicChannel} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTTicketSales.path} component={ClassicTicketSales} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTReward.path} component={ClassicReward} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTBigReward.path} component={ClassicBigReward} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTPeriod.path} component={ClassicPeriod} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTNewCart.path} component={ClassicNewCart} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTDoneCart.path} component={ClassicDoneCart} />
      <RouteWithClassicMTSidebar region={'MT'} exact path={Routes.ClassicMTSearch.path} component={ClassicSearch} />

      {/* CLASSIC MB */}
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBTicketSales.path} component={ClassicTicketSales} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBReward.path} component={ClassicReward} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBBigReward.path} component={ClassicBigReward} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBPeriod.path} component={ClassicPeriod} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBNewCart.path} component={ClassicNewCart} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBDoneCart.path} component={ClassicDoneCart} />
      <RouteWithClassicMBSidebar region={'MB'} exact path={Routes.ClassicMBSearch.path} component={ClassicSearch} />

      {/* CLASSIC MN */}
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNChannel.path} component={ClassicChannel} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNTicketSales.path} component={ClassicTicketSales} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNReward.path} component={ClassicReward} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNBigReward.path} component={ClassicBigReward} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNPeriod.path} component={ClassicPeriod} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNNewCart.path} component={ClassicNewCart} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNDoneCart.path} component={ClassicDoneCart} />
      <RouteWithClassicMNSidebar region={'MN'} exact path={Routes.ClassicMNSearch.path} component={ClassicSearch} />

      {/* LOTO */}
      <RouteWithLotoSidebar exact path={Routes.LotoChannel.path} component={LotoChannel} />
      <RouteWithLotoSidebar exact path={Routes.LotoPeriod.path} component={LotoPeriod} />
      <RouteWithLotoSidebar exact path={Routes.LotoSearch.path} component={LotoSearch} />
      <RouteWithLotoSidebar exact path={Routes.LotoDoneCart.path} component={LotoDoneCart} />
      <RouteWithLotoSidebar exact path={Routes.LotoNewCart.path} component={LotoNewCart} />
      <RouteWithLotoSidebar exact path={Routes.LotoReward.path} component={LotoReward} />
      <RouteWithLotoSidebar exact path={Routes.LotoBigReward.path} component={LotoBigReward} />
      <RouteWithLotoSidebar exact path={Routes.LotoStatisticByTicket.path} component={LotoStatisticByTicket} />

      {/* SETTING */}
      <RouteWithSettingSidebar exact path={Routes.SettingMaintained.path} component={Maintained} />
      <RouteWithSettingSidebar exact path={Routes.SettingTicketRoll.path} component={TicketRoll} />
      <RouteWithSettingSidebar exact path={Routes.SettingWorkerQueue.path} component={WorkerQueue} />
      <RouteWithSettingSidebar exact path={Routes.SettingServerBenchmark.path} component={ServerBenchmark} />
      <RouteWithSettingSidebar exact path={Routes.SettingDevices.path} component={Devices} />
      <RouteWithSettingSidebar exact path={Routes.SettingNotification.path} component={Notification} />
      <RouteWithSettingSidebar exact path={Routes.SettingGames.path} component={Games} />
      <RouteWithSettingSidebar exact path={Routes.SettingPaymentMethod.path} component={PaymentMethod} />
      <RouteWithSettingSidebar exact path={Routes.SettingAccount.path} component={Account} />
      <RouteWithSettingSidebar exact path={Routes.SettingBank.path} component={Bank} />
      <RouteWithSettingSidebar exact path={Routes.SettingBanner.path} component={Banner} />
      <RouteWithSettingSidebar exact path={Routes.SettingPrivacy.path} component={Privacy} />
      <RouteWithSettingSidebar exact path={Routes.SettingContact.path} component={Contact} />
      <RouteWithSettingSidebar exact path={Routes.SettingInvite.path} component={Invite} />
      <RouteWithSettingSidebar exact path={Routes.SettingEmployee.path} component={Employee} />
      <RouteWithSuperAdminSidebar exact path={Routes.AdminManagement.path} component={AdminManagement} />
      <RouteWithSuperAdminSidebar exact path={Routes.TicketEmployeeManagement.path} component={TicketEmployeeManagement} />
      <RouteWithSettingSidebar exact path={Routes.SettingSystemNotification.path} component={SystemNotification} />

      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
}
